import LxcError from "~/core/models/LxcError.class";
import type { CartographySettings } from "~/modules/cartography/models/CartographySettings.interface";
import cartographyService from "~/modules/cartography/services/cartography.service";

export function useCartography() {
  const cartographySettings: Ref<CartographySettings | undefined> = ref();
  const error: Ref<LxcError | undefined> = ref();
  const isLoading: Ref<boolean> = ref(false);

  async function getCartographySettings() {
    isLoading.value = true;

    const response = await cartographyService.getCartographySettings();

    if (LxcError.check(response)) {
      error.value = response;
      cartographySettings.value = undefined;
    } else {
      error.value = undefined;
      cartographySettings.value = response;
    }

    isLoading.value = false;
  }

  return {
    error,
    isLoading,
    cartographySettings,
    getCartographySettings,
  };
}
